
<!-- <router-outlet></router-outlet> -->
<div *ngIf="displayMainetance;else navBar">
  <app-dashboard></app-dashboard>
</div>
<ng-template #navBar>
  <app-app-nav-bar></app-app-nav-bar>
</ng-template>
